import React from 'react';
import { AlertTriangle, Shield, Lock } from 'lucide-react';

interface AccessDeniedProps {
  message?: string;
  requiredRole?: string;
  currentRole?: string;
}

const AccessDenied: React.FC<AccessDeniedProps> = ({ 
  message = "Acceso restringido. No tienes permisos para realizar esta acción.",
  requiredRole,
  currentRole
}) => {
  return (
    <div className="flex items-center justify-center min-h-[200px] p-8">
      <div className="text-center max-w-md">
        <div className="flex justify-center mb-4">
          <div className="p-4 bg-red-100 rounded-full">
            <AlertTriangle className="w-8 h-8 text-red-600" />
          </div>
        </div>
        
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          Acceso Restringido
        </h3>
        
        <p className="text-gray-600 mb-4">
          {message}
        </p>
        
        {requiredRole && currentRole && (
          <div className="bg-gray-50 rounded-lg p-4 mb-4">
            <div className="flex items-center justify-between text-sm">
              <div className="flex items-center space-x-2">
                <Shield className="w-4 h-4 text-gray-500" />
                <span className="text-gray-700">Rol requerido:</span>
                <span className="font-medium text-gray-900">{requiredRole}</span>
              </div>
              <div className="flex items-center space-x-2">
                <Lock className="w-4 h-4 text-gray-500" />
                <span className="text-gray-700">Tu rol:</span>
                <span className="font-medium text-gray-900">{currentRole}</span>
              </div>
            </div>
          </div>
        )}
        
        <div className="text-xs text-gray-500">
          Contacta al administrador si necesitas acceso a esta función.
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
